import React from "react";

class Upcharges extends React.Component {
  render() {
    let upcharges = this.props.upchargesList.map((upcharge, index) => {
      return <li key={index}>{upcharge}</li>;
    });
    return (
      <div className="upcharge-description digital-proof-desc">
        <h3 className="upcharge-description__header">Price includes:</h3>
        <ul>{upcharges}</ul>
      </div>
    );
  }
}

export default Upcharges;
